function init() {
  const button = document.querySelector('.c-hamburger__patty');

  if (!button) {
    return;
  }

  button.addEventListener('click', (e) => {
    e.preventDefault();
    if (button.innerHTML == "Close") {
        button.innerHTML = "Menu";
    } else {
      button.innerHTML = "Close";
    }
  });
}

export default init;
